import { memo, useState } from 'react'
import { DeliveryTypeEnum } from 'modules/deliveryInfo/types'
import { TScheduleDay } from 'modules/terminal/types'

import { FieldOrderGuestDateBlockForm } from './FieldOrderGuestDateBlockForm'
import { FieldOrderGuestRoutesBlockForm } from './FieldOrderGuestRoutesBlockForm'

export const OrderGuestRoutesDateBlockForm = memo(function OrderGuestRoutesDateBlockForm() {
  const [departureTerminalId, setDepartureTerminalId] = useState('')
  const [destinationTerminalId, setDestinationTerminalId] = useState('')
  const [departureType, setDepartureType] = useState<DeliveryTypeEnum | undefined>()
  const [destinationType, setDestinationType] = useState<DeliveryTypeEnum | undefined>()
  const [departureTerminalSchedule, setDepartureTerminalSchedule] = useState<TScheduleDay[] | undefined>()
  const [destinationTerminalSchedule, setDestinationTerminalSchedule] = useState<TScheduleDay[] | undefined>()

  return (
    <div>
      <FieldOrderGuestRoutesBlockForm
        departureTerminalId={departureTerminalId}
        destinationTerminalId={destinationTerminalId}
        setDepartureTerminalId={setDepartureTerminalId}
        setDepartureTerminalSchedule={setDepartureTerminalSchedule}
        setDepartureType={setDepartureType}
        setDestinationTerminalId={setDestinationTerminalId}
        setDestinationTerminalSchedule={setDestinationTerminalSchedule}
        setDestinationType={setDestinationType}
      />
      <FieldOrderGuestDateBlockForm
        departureTerminalId={departureTerminalId}
        departureTerminalSchedule={departureTerminalSchedule}
        departureType={departureType}
        destinationTerminalId={destinationTerminalId}
        destinationTerminalSchedule={destinationTerminalSchedule}
        destinationType={destinationType}
      />
    </div>
  )
})
